import ExquraNavbar from "@/components/home/ExquraNavbar";
import { useSiteContent } from "./useSiteContent";

/** Same self-fetching singleton pattern as SiteFooter/SiteMasthead — the
 * public navbar is shared chrome (rendered by Home.jsx directly and by
 * Layout.jsx for every other public page), not a block inside any one
 * page's own content array. Edited under Edit Site's "Navigation" entry. */
export default function SiteNavbar() {
  const { blocks } = useSiteContent("navbar");
  return <ExquraNavbar fields={blocks[0]?.fields} />;
}
